import React from 'react'
import tinycolor from 'tinycolor2'

import { Checkbox, Fieldset, Subsection, getCssVariable } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { ColorInput } from '../ColorInput'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  verified?: boolean
}

export const UsernameStyling = ({ form, verified }: Props) => {
  const colorOnBackground = getCssVariable('--color-on-background')

  return (
    <Subsection title="Username styling">
      <Fieldset>
        <Fieldset.Row>
          <Checkbox
            label={
              verified
                ? 'Team members using this badge have a custom username color'
                : 'Members using this badge have a custom username color'
            }
            {...form.getFieldProps(FormFields.useCustomUsernameColor)}
          />
        </Fieldset.Row>
        {form.values.useCustomUsernameColor && (
          <Fieldset.Row inner>
            <ColorInput
              label="Username text color"
              color={form.values.usernameTextColor}
              defaultColor={tinycolor(colorOnBackground).toRgbString()}
              onChange={(color) => form.setFieldValue(FormFields.usernameTextColor, color)}
            />
          </Fieldset.Row>
        )}
      </Fieldset>
    </Subsection>
  )
}
